import { createContext } from 'react'

export * from './Slide'
export * from './Slider'

export const sliderContext = createContext({ isMoving: false, setIsMoving: (value: boolean) => {} })
export const SliderContextProvider = sliderContext.Provider
